module.exports = {"410212100":"城关镇","410212101":"陈留镇","410212102":"仇楼镇","410212103":"八里湾镇","410212104":"曲兴镇","410212106":"朱仙镇","410212200":"半坡店乡","410212202":"罗王乡","410212203":"刘店乡","410212204":"袁坊乡","410212205":"杜良乡","410212206":"兴隆乡","410212208":"西姜寨乡","410212210":"万隆乡","410212211":"范村乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410212.json
// module id = 1406
// module chunks = 0